import { useContext } from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { P1 } from 'src/components/Typography/Paragraph';

import classes from './TopLabel.module.scss';

export function TopLabel() {
  const { script } = useContext(FormParserContext);

  if (!script.topLabel) return <></>;

  return <P1 className={classes.label}>{script.topLabel}</P1>;
}
